import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetSitesRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSites`,
	params: { userId, role },
	hasLoading: false
});

export const GetSiteDetailsRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteDetails`,
	params: { userId, tableId }
});

export const GetSiteAttachmentsRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteAttachments`,
	params: { userId, tableId }
});

export const GetSiteDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteDropdowns`
});

export const GetSitesIdsRequest = (mocnActivationDateF, phase) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSitesIds`,
	params: {mocnActivationDateF, phase}
});

export const EditSiteDetailsRequest = siteTrackerDto => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/EditSiteDetails`,
	data: siteTrackerDto
});

export const CreateSiteRequest = siteTrackerDto => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/CreateSite`,
	data: siteTrackerDto
});

export const DeleteSiteRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/DeleteSite`,
	params: { userId, tableId }
});

export const ExportSitesRequest = (userId, type, filter) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/ExportSites`,
	params: { userId, type, filter }
});

export const ExportTestingRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/ExportTesting`,
	params: { userId }
});

export const ExportSitesByTypeRequest = (userId, filter) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/ExportSitesByType`,
	params: { userId, filter }
});

export const FileUpdateSitesSiteTrackerRequest = (userId, filePath) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/FileUpdateSites`,
	params: { userId, filePath }
});

export const FileUpdateSitesCommitSiteTrackerRequest = (userId, proximitiesUpdate) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/FileUpdateSitesCommit`,
	params: { userId, proximitiesUpdate }
});

export const ImportValidationsSiteTrackerRequest = (userId, filePath) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/ImportValidations`,
	params: { userId, filePath }
});

export const GetAutocompleteFieldsRequest = siteId => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetAutocompleteFields`,
	params: { siteId }
});

export const AddAttachmentsRequest = (userId, tableId, title, folderPath, image) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/AddAttachments`,
	data: { userId, tableId, title, folderPath, image }
});

export const DownloadAttachmentsRequest = (userId, tableId, title) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/DownloadAttachments`,
	params: { userId, tableId, title }
});

export const DownloadAttachmentRequest = (userId, id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/DownloadAttachment`,
	params: { userId, id }
});

export const RemoveAttachmentsRequest = (userId, tableId, title) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/RemoveAttachments`,
	params: { userId, tableId, title }
});

export const RemoveAttachmentRequest = (userId, id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/RemoveAttachment`,
	params: { userId, id }
});

export const GetCommentsRequest = (tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetComments`,
	params: { tableId }
});

export const AddCommentRequest = (userId, tableId, title, comment) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/AddComment`,
	params: { userId, tableId, title, comment }
});

export const AddDropdownFieldRequest = (userId, name, value, relations) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/AddDropdownField`,
	data: { userId, name, value, relations }
});

export const RemoveDropdownFieldRequest = (userId, name, value, id, relations) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/RemoveDropdownField`,
	data: { userId, name, value, id, relations }
});

export const CopyFileRequest = (number) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/CopyFile`,
	params: { number }
});

export const UpdateSitesRequest = (userId, fieldType, fieldTypeValue, fieldName, fieldValue, phase) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/UpdateSites`,
	data: { userId, fieldType, fieldTypeValue, fieldName, fieldValue, phase}
});

// Datatable
export const ChangeColumnVisibilityRequest = (changeColumn) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Datatable/ChangeColumnVisibility`,
	data: changeColumn
});

export const GetVisibleColumnsRequest = (userId, tableName) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Datatable/GetVisibleColumns`,
	params: { userId, tableName }
});

export const ChangeFilterVisibilityRequest = (changeColumn) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Datatable/ChangeFilterVisibility`,
	data: changeColumn
});

export const GetAllUploadInfoRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetAllLastUpdateInfos`
});

export const GetVisibleFiltersRequest = (userId, tableName) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Datatable/GetVisibleFilters`,
	params: { userId, tableName }
});

export const ImportDependenciesManualDataRequest = (userId, filePath, owner) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/ImportDependenciesManualData`,
	params: { userId, filePath, owner }
});

export const GetDependenciesManualDataOwnersRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetDependenciesManualDataOwners`
});

export const AuditSitesRequest = (userId, vendor) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/ExportSiteTrackerAudit`,
	params: { userId, vendor }
});
